import { render, staticRenderFns } from "./StaticMulSelect.vue?vue&type=template&id=06625102&"
import script from "./StaticMulSelect.vue?vue&type=script&lang=js&"
export * from "./StaticMulSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports